import { RouteUrlBucket } from "cruzo";
import { BookExercisesComponent } from "site/components/book-exercises/book-exercises.component";
import { BooksComponent } from "site/components/books/books.component";
import { ExerciseComponent } from "site/components/exercise/exercise.component";
import { PaymentStatusComponent } from "site/components/payment-status/payment-status.component";
import { PromoComponent } from "site/components/promo/promo.component";

export const routerUrlBucket = new RouteUrlBucket({
  main: {
    url: '/',
    componentSelectorUnbox: () => PromoComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  books: {
    url: '/books',
    componentSelectorUnbox: () => BooksComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  book_exercises: {
    url: '/books/:bookId',
    componentSelectorUnbox: () => BookExercisesComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  exercise: {
    url: '/books/:bookId/:exerciseId',
    componentSelectorUnbox: () => ExerciseComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  exercise_edit: {
    url: '/books/:bookId/:exerciseId/edit',
    loadResources: () => {
      return import("site/components/exercise-editor/exercise-editor.component")
    },
    componentSelectorUnbox: () => "exercise-editor-component",
    routeSelectorUnbox: () => ".section"
  },
  payment_return: {
    url: '/payment/return',
    componentSelectorUnbox: () => PaymentStatusComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  payment_fail: {
    url: '/payment/fail',
    componentSelectorUnbox: () => PaymentStatusComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
  payment_already_confirmed: {
    url: '/payment/already-confirmed',
    componentSelectorUnbox: () => PaymentStatusComponent.selector,
    routeSelectorUnbox: () => ".section"
  },
})